module.exports = require('./helpers/bundle-url').getBundleURL('hGepg') + "logo.7718c6df.svg";